<template>
  <div class="f-eventsPage">

    <div class="title-container">
      <h1>{{activeLanguage.events}}</h1>
    </div>

    <b-row class="buttons-wrapper">
      <b-col>
        <button :class="[ iconWrapper]"
                @click="changeEventsStatus('UpcomingEvents')">
          <div class="inline-label">
            <div aria-label="Enable Events" class="icon checkbox-enabled "
                 role="presentation" title="Enable Events" v-if="eventFilter.UpcomingEvents"></div>
            <div aria-label="Disable Events" class="icon checkbox-disabled " role="presentation" title="Disable Events"
                 v-else></div>
            <p :class="[eventFilter.UpcomingEvents ? `activeLabel` : `disabledLabel`]">{{activeLanguage.events}}</p>
          </div>
        </button>
      </b-col>
      <b-col>
        <button :class="[ iconWrapper]"
                @click="changeEventsStatus('PastEvents')">
          <div class="inline-label-long">
            <div aria-label="Enable Past Events" class="icon checkbox-enabled"
                 role="presentation" title="Enable Past Events" v-if="eventFilter.PastEvents"></div>
            <div aria-label="Disable Past Events" class="icon checkbox-disabled " role="presentation"
                 title="Disable Past Events"
                 v-else></div>
            <p :class="[eventFilter.PastEvents ? `activeLabel` : `disabledLabel`]">{{activeLanguage.pastEvents}}</p>
          </div>
        </button>
      </b-col>
    </b-row>

    <div infinite-scroll-disabled="busy" infinite-scroll-distance="30"
         v-infinite-scroll="">
      <transition mode="out-in" name="fade">
        <div key="1" v-if="isLoadingContent">
          <p class="loading-subtitle">{{activeLanguage.contentLoading}}</p>
          <grid-loader :loading="isLoadingContent" color="#c41c21" size="40px"
                       style="width: 100%"></grid-loader>
        </div>

        <div key="2" v-else-if="isEmptyContent">
          <p class="loading-subtitle">{{activeLanguage.contentEmpty}}</p>
          <div class="empty-box"></div>
        </div>

        <div key="3" v-else>
          <!--<div class="post-container">-->
            <!--<div class="wrapper">-->
              <!--<div class="masonry-container-new">-->
                <!--<div :key="index" class="brick"-->
                     <!--v-for="(post, index) in posts">-->
                  <!--<event-card :post-content="post" style="max-width: 285px !important;"/>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->

          <!--</div>-->

          <div :fit-width="true" class="post-container" item-selector=".item" transition-duration="0.3s"
               v-masonry>
            <div :key="index" class="item" v-for="(post, index) in posts" v-masonry-tile>
              <event-card :post-content="post" style="max-width: 285px !important;"/>
            </div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import EventCard from '../../utilComponents/EventCard'
  import Vue from 'vue'
  import {VueMasonryPlugin} from 'vue-masonry'

  Vue.use(VueMasonryPlugin)

  export default {
    name: 'EventsPage',
    components: {EventCard, GridLoader},
    data () {
      return {
        isLoadingState: true,
        posts: [],
        eventFilter: {'UpcomingEvents': true, 'PastEvents': false},
        iconWrapper: 'icon-wrapper'
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      isLoadingContent () {
        return this.isLoadingState
      },
      isEmptyContent () {
        return this.posts.length === 0 && !this.isLoadingState
      }
    },
    methods: {
      handleError (err) {
        if (err.status >= 500) {
          console.log('Server-Related problem')
        } else if (err.status === 400) {
          console.log('A bad request occurred')
        } else if (err.status === 404) {
          console.log(err.body.message)
        }
      },
      fetchEventsOnLoad () {
        this.isLoadingState = true
        this.posts = []
        let self = this
        this.$http.get(this.$PATH_NAME + 'events/get20/').then((response) => {
          if (response.status === 200) {
            self.posts = response.body
          }
        }).catch(function (err) {
          this.handleError(err)
        }).finally(function () {
          this.isLoadingState = false
        })
      },
      fetchEventsOnLoadMore () {
        let self = this
        if (this.posts[this.posts.length - 1]) {
          let lastId = this.posts[this.posts.length - 1].datePublished
          this.$http.get(this.$PATH_NAME + 'events/get20&fromId=' + lastId + '/').then((response) => {
            response.body.forEach((post) => {
              self.posts.push(post)
            })
          }
          ).catch(function (err) {
            this.handleError(err)
          })
        }
      },
      fetchPastEvents () {
        this.isLoadingState = true
        this.posts = []
        let self = this
        this.$http.get(this.$PATH_NAME + 'events/getPastEvents/').then((response) => {
          if (response.status === 200) {
            self.posts = response.body
          }
        }).catch(function (err) {
          this.handleError(err)
        }).finally(function () {
          this.isLoadingState = false
        })
      },
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['selected-bg', 'selected-text']
        } else {
          return ['non-selected-bg', 'non-selected-text']
        }
      },
      changeEventsStatus (eventType) {
        this.eventFilter[eventType] = !this.eventFilter[eventType]
        if (eventType === 'UpcomingEvents' && !this.eventFilter['PastEvents']) {
          this.eventFilter['PastEvents'] = !this.eventFilter['PastEvents']
        }
        if (eventType === 'UpcomingEvents' && this.eventFilter['PastEvents']) {
          this.eventFilter['PastEvents'] = !this.eventFilter['PastEvents']
        }
        if (eventType === 'PastEvents' && !this.eventFilter['UpcomingEvents']) {
          this.eventFilter['UpcomingEvents'] = !this.eventFilter['UpcomingEvents']
        }
        if (eventType === 'PastEvents' && this.eventFilter['UpcomingEvents']) {
          this.eventFilter['UpcomingEvents'] = !this.eventFilter['UpcomingEvents']
        }
        this.updatePosts()
      },
      updatePosts () {
        this.isLoadingState = true
        this.posts = []
        let self = this
        setTimeout(function () {
          if (self.eventFilter['UpcomingEvents']) {
            self.fetchEventsOnLoad()
          } else {
            self.fetchPastEvents()
          }
        }, 1)
      }
    },
    mounted () {
      this.fetchEventsOnLoad()
      // setTimeout(function () {
      //   let tabs = document.getElementById('__BVID__13__BV_tab_controls_').getElementsByTagName('LI')
      //   console.log(tabs.item(0))
      //   // tabs.item(0).getElementsByTagName('a').item(0).setAttribute('style', 'color: #c41c21 !important;')
      // }, 50)
    }
  }
</script>

<style scoped>

  .f-eventsPage {
    margin-top: 0 !important;
    width: 100%;
    height: 100%;
  }

  .loading-subtitle {
    font-size: 3vh;
    font-weight: bold;
    color: #888;
  }

  .post-container {
    margin: 0 auto;
  }

  .icon {
    display: inline-block !important;
    height: 1.25em !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    vertical-align: text-bottom !important;
    margin: 0;
  }

  .buttons-wrapper {
    padding-left: 10%;
    padding-right: 10%;
    margin: 0 auto 1%;
  }

  .checkbox-disabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQ0IDQ0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0NCA0NCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CiAgPHBhdGggZD0ibTIyLDBjLTEyLjIsMC0yMiw5LjgtMjIsMjJzOS44LDIyIDIyLDIyIDIyLTkuOCAyMi0yMi05LjgtMjItMjItMjJ6bTMuMiwyMi40bDcuNSw3LjVjMC4yLDAuMiAwLjMsMC41IDAuMywwLjdzLTAuMSwwLjUtMC4zLDAuN2wtMS40LDEuNGMtMC4yLDAuMi0wLjUsMC4zLTAuNywwLjMtMC4zLDAtMC41LTAuMS0wLjctMC4zbC03LjUtNy41Yy0wLjItMC4yLTAuNS0wLjItMC43LDBsLTcuNSw3LjVjLTAuMiwwLjItMC41LDAuMy0wLjcsMC4zLTAuMywwLTAuNS0wLjEtMC43LTAuM2wtMS40LTEuNGMtMC4yLTAuMi0wLjMtMC41LTAuMy0wLjdzMC4xLTAuNSAwLjMtMC43bDcuNS03LjVjMC4yLTAuMiAwLjItMC41IDAtMC43bC03LjUtNy41Yy0wLjItMC4yLTAuMy0wLjUtMC4zLTAuN3MwLjEtMC41IDAuMy0wLjdsMS40LTEuNGMwLjItMC4yIDAuNS0wLjMgMC43LTAuM3MwLjUsMC4xIDAuNywwLjNsNy41LDcuNWMwLjIsMC4yIDAuNSwwLjIgMC43LDBsNy41LTcuNWMwLjItMC4yIDAuNS0wLjMgMC43LTAuMyAwLjMsMCAwLjUsMC4xIDAuNywwLjNsMS40LDEuNGMwLjIsMC4yIDAuMywwLjUgMC4zLDAuN3MtMC4xLDAuNS0wLjMsMC43bC03LjUsNy41Yy0wLjIsMC4xLTAuMiwwLjUgMy41NTI3MWUtMTUsMC43eiIgZmlsbD0iIzAwMDAwMCIvPgo8L3N2Zz4K");
  }

  .checkbox-enabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQ0IDQ0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0NCA0NCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CiAgPHBhdGggZD0ibTIyLDBjLTEyLjIsMC0yMiw5LjgtMjIsMjJzOS44LDIyIDIyLDIyIDIyLTkuOCAyMi0yMi05LjgtMjItMjItMjJ6bTEyLjcsMTUuMWwwLDAtMTYsMTYuNmMtMC4yLDAuMi0wLjQsMC4zLTAuNywwLjMtMC4zLDAtMC42LTAuMS0wLjctMC4zbC03LjgtOC40LS4yLS4yYy0wLjItMC4yLTAuMy0wLjUtMC4zLTAuN3MwLjEtMC41IDAuMy0wLjdsMS40LTEuNGMwLjQtMC40IDEtMC40IDEuNCwwbC4xLC4xIDUuNSw1LjljMC4yLDAuMiAwLjUsMC4yIDAuNywwbDEzLjQtMTMuOWgwLjFjMC40LTAuNCAxLTAuNCAxLjQsMGwxLjQsMS40YzAuNCwwLjMgMC40LDAuOSAwLDEuM3oiIGZpbGw9IiNjNDFjMjEiLz4KPC9zdmc+Cg==");
  }

  .icon-wrapper {
    border: 3px solid #eee;;
    border-radius: 15px;
    background-color: white;
    width: 80%;
    height: 55px;
    cursor: pointer;
  }

  .icon-wrapper:focus {
    outline: none;
    /*box-shadow: 0 0 1pt 1pt red;*/
  }

  .inline-label {
    display: -webkit-inline-box;
  }

  .inline-label > p {
    margin-left: 15%;
    padding: 0 20% 0 0;
  }

  .disabled {
    opacity: 0.3;
  }

  .activeLabel {
    font-weight: bold;
    color: #c41c21 !important;
  }

  .disabledLabel {
    font-weight: bold;
    color: black;
  }

  .fullscreen {
    padding: 0;
    background: white;
    width: 100%;
    height: 100%;
  }

  .inline-label-long {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .inline-label-long > p {
    margin-left: 2% !important;
    padding: 0 0 0 0 !important;
  }

  /*---------------------------------------------------------------*/
  /* Masonry grid */
  .masonry-container-new {
    transition: all .5s ease-in-out;
    column-gap: 0;
    column-fill: initial;
  }

  /* Masonry item */
  .masonry-container-new .brick {
    margin-bottom: 0;
    display: inline-block; /* Fix the misalignment of items */
    vertical-align: top; /* Keep the item on the very top */
  }

  /* Masonry image effects */
  .masonry-container-new .brick img {
    transition: all .5s ease-in-out;
    backface-visibility: hidden; /* Remove Image flickering on hover */
  }

  .masonry-container-new .brick:hover img {
    opacity: .75;
  }

  /* Masonry on tablets */
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    .masonry-container-new {
      column-count: 2;
    }
  }

  /* Masonry on big screens */
  @media only screen and (min-width: 1024px) {
    .desc {
      font-size: 1.25em;
    }

    .intro {
      letter-spacing: 1px;
    }

    .masonry-container-new {
      column-count: 3;
    }
  }

  .wrapper {
    margin-left: auto;
    margin-right: auto;
    /*padding-right: 1.5em;*/
    /*padding-left: 1.5em;*/
    max-width: 85%;
  }

  /*-----------------------------------------------------------------------*/

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/eventsPageComponents/EventsPage.vue